module.exports = __webpack_public_path__ + "img/t3-7.b881a9e8.jpg";